import React from 'react';
import { Mosaic } from "react-loading-indicators";

const Preloader = () => {
    return (
        <div className="preloader-overlay">
            <div className="preloader-content">
                <Mosaic color={["#7a6a1d", "#a38d27", "#ccb131", "#d7c159"]} size="large" text="" textColor="" />
            </div>
        </div>
    );
};

export default Preloader;
